module.exports = { "default": require("core-js/library/fn/number/is-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/is-integer.js
// module id = 800
// module chunks = 47